
import { defineComponent } from 'vue'
export default defineComponent({
    name: 'logistStatus',
    props: {
        logisticsData: {
            type: Object,
            default: ()=>{return {}}
        },
        typeStr: {
            type: String
        },
    },
    setup(props){
        console.log('子组件',props.logisticsData)
        //格式化表格显示内容
        const changeTxt = (val:string | number, type: string):string => {
            let txt = ''
            const txtEtyObj = {0: '未审核',1: '审核中',2:'审核通过',3:'审核不通过'}
            const txtDef = {default: `${val}`}
            switch(type){
                case 'auditStatus':
                    txt = txtEtyObj[val] || txtDef['default']
                    break
                default:
                    txt = txtDef['default']
                    break
            }
            return txt
        }

        const { logisticsData } = props
        const columns = [
            {title: '事件发生时间',dataIndex: 'eventTime'},
            {title: '国家二字码',dataIndex: 'countryCode2'},
            {title: '订单状态',dataIndex: 'eventCodeCn'},
        ]


        return {
            changeTxt,
            columns,
            logisticsData
        }
    }
})
